import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const numberUiNodeSpec: UiNodeSpec<'number'> = {
    requiredSockets: 'all',
    cfg: () => ({ controlValues: { value: 0 }, id: getUID(), kind: 'number', disabled: false }),
    controls: getNodeCfg => ({ value: { cfg: { kind: 'number', label: 'Value' }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.value } }),
    inputs: () => ({}),
    kindLabel: 'Number',
    nodeCategory: 'number',
    outputs: () => ({ output: { socket: 'number', label: 'Output' } }),
    validator: node => {
        const errors: Record<string, string> = {};
        if (typeof node.controlValues.value !== 'number' || isNaN(node.controlValues.value)) {
            errors.value = 'Value must be a number';
        }
        return Object.keys(errors).length ? errors : true;
    },
};
